import ConstCode from '@/common/constants/ConstCode';
import { dashboard } from '@/common/service/ApiList';
import { assist } from '@/common/utils/ParameterAssistant';
import ServiceExec from '@/common/utils/ServiceExec';

const { classify, transaction, sales, count } = dashboard;

const actions = {
  FETCH_CLASSIFY: async ({ state, commit }) => {
    //분류
    const params = { storeNo: state.classify.storeNo, date: state.date, isClassify: true };
    const { status, data } = await ServiceExec.get(classify, params);

    commit('setClassifyResult', data);
  },
  FETCH_TRANSACTION: async ({ state, commit }) => {
    //거래 이벤트
    const { storeNo, periodCondition } = state.transaction;

    if (!storeNo || !periodCondition) return;
    const params = { storeNo, periodCondition, date: state.date, isClassify: false };
    const { status, data } = await ServiceExec.get(transaction, params);

    commit('setTransactionData', data);
  },
  FETCH_SALES: async ({ state, commit }) => {
    //매출금액
    const { storeNo, salesPeriodCondition, orderCondition } = state.countAndSales;

    if (!storeNo || !salesPeriodCondition || !orderCondition) return;
    const params = { storeNo: storeNo, periodCondition: salesPeriodCondition, orderCondition, date: state.date };
    const { status, data } = await ServiceExec.get(sales, params);

    commit('setSalesData', data);
  },
  FETCH_COUNT: async ({ state, commit }) => {
    //주문건수
    const { storeNo, countPeriodCondition, orderCondition } = state.countAndSales;

    if (!storeNo || !countPeriodCondition || !orderCondition) return;
    const params = { storeNo, periodCondition: countPeriodCondition, orderCondition, date: state.date };
    const { status, data } = await ServiceExec.get(count, params);

    commit('setCountData', data);
  }
};
export default actions;
